export const getError = (errorObject) => {
  if (!errorObject) return null;
  if (errorObject.type === 'required') return 'A quote file is required';
  return 'There is an issue with this file';
};
